export default __webpack_public_path__ + "static/reporting.url-39b6252bee365ec7cdae114f3cb1a58f.svg";